import { useState } from 'react';
import { Button } from 'antd';
import { useReactToPrint } from 'react-to-print';
import withLocale from '../../withLocale';

const PrintButtonInner = ({ content, onSuccess, onError, onBeforePrint, printProps, contentRef, ...props }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handler = useReactToPrint({
    contentRef,
    bodyClass: document.body.getAttribute('class'),
    onBeforePrint: async (...args) => {
      setIsLoading(true);
      onBeforePrint && (await onBeforePrint(...args));
    },
    onPrintError: (...args) => {
      setIsLoading(false);
      onError && onError(...args);
    },
    onAfterPrint: (...args) => {
      setIsLoading(false);
      onSuccess && onSuccess(...args);
    },
    ...printProps
  });
  return (
    <Button
      {...props}
      onClick={() => {
        setIsLoading(true);
        handler();
      }}
      loading={isLoading}
    />
  );
};

const PrintButton = withLocale(PrintButtonInner);

export { PrintButtonInner };
export default PrintButton;
